import { Action, combineReducers, configureStore } from '@reduxjs/toolkit';
import { ThunkAction } from 'redux-thunk';

/*
|-----------------------------------------------------------------
| Import reducers and export reducer actions
|-----------------------------------------------------------------
|
*/
/* PLOP_INJECT_IMPORT */
// -- import logoutTimeoutModal reducer
import logoutTimeoutModalReducer from './reducers/logoutTimeoutModal/logoutTimeoutModal.reducer';
// -- export logoutTimeoutModal actions & selectors
export {
  logoutTimeoutModalActions,
  logoutTimeoutModalSelectors
} from './reducers/logoutTimeoutModal/logoutTimeoutModal.reducer';

// -- import accessibility reducer
import accessibilityReducer from './reducers/accessibility/accessibility.reducer';
// -- export accessibility actions & selectors
export {
  accessibilityActions,
  accessibilitySelectors
} from './reducers/accessibility/accessibility.reducer';

// -- import documents reducer
import documentsReducer from './reducers/documents/documents.reducer';
// -- export documents actions & selectors
export {
  documentsActions,
  documentsSelectors
} from './reducers/documents/documents.reducer';

// -- import layout reducer
import layoutReducer from './reducers/layout/layout.reducer';
// -- export layout actions & selectors
export {
  layoutActions,
  layoutSelectors
} from './reducers/layout/layout.reducer';

// -- import user reducer
import userReducer from './reducers/user/user.reducer';
// -- export user actions & selectors
export { userActions, userSelectors } from './reducers/user/user.reducer';

/*
|-----------------------------------------------------------------
| Combine Reducers
|-----------------------------------------------------------------
|
*/

const rootReducer = combineReducers({
  /* PLOP_INJECT_COMBINE */
  accessibility: accessibilityReducer,
  documents: documentsReducer,
  user: userReducer,
  layout: layoutReducer,
  logoutTimeoutModal: logoutTimeoutModalReducer
});

/*
|-----------------------------------------------------------------
| Create store
|-----------------------------------------------------------------
|
*/
const store = configureStore({
  reducer: rootReducer
});

// if (process.env.NODE_ENV === 'development' && module.hot) {
//   module.hot.accept('./rootReducer', () => {
//     const newRootReducer = require('./rootReducer').default
//     store.replaceReducer(newRootReducer)
//   })
// }

export type RootState = ReturnType<typeof rootReducer>;

export type AppDispatch = typeof store.dispatch;

export type AppThunk = ThunkAction<void, RootState, null, Action<string>>;

export default store;
